import React from "react";
import "./Button.scss"
const Button = ({ text, isloading, onClick, width, isSecondary = false, isBorder = false }) => {
    return (
        <div className={`VirasatV2Default-Button VirasatV2Default-SecButton ${isSecondary ? "VirasatV2Default-SecButton" : isBorder ? "VirasatV2Default-borderButton" : ""}`} onClick={onClick} style={{ width }}>
            {isloading && <div className="loader-btn" />}
            {text}
        </div>
    )
}
export default Button